import { Update } from '../../types';

export const updateData = (
  prevUpdate: Update,
  payload: Update,
  action: 'price' | 'availability',
  productId: string
): boolean => {
  const applyOverrides = () => {
    const overrides = payload.overrides;
    if (overrides === undefined) {
      return;
    }
    if (overrides.length === 0) {
      delete prevUpdate.overrides;
      return;
    }
    const prevOverrides = prevUpdate.overrides || [];
    const updatedOverrides = [...prevOverrides];
    for (const payloadOverride of overrides) {
      const existingIndex = updatedOverrides.findIndex(o => o.id === payloadOverride.id);
      if (existingIndex >= 0) {
        updatedOverrides[existingIndex] = {
          ...updatedOverrides[existingIndex],
          availability: payloadOverride.availability,
        };
      } else {
        updatedOverrides.push({ ...payloadOverride });
      }
    }
    prevUpdate.overrides = updatedOverrides;
  };
  const updatePrice = (): boolean => {
    const hasOverridesOnly = !payload.price && payload.overrides;
    const hasValidPriceOrAvailability =
      typeof payload.price === 'number' || typeof prevUpdate.availability === 'boolean';
    if (hasOverridesOnly) {
      prevUpdate.overrides = payload.overrides;
      return true;
    }
    if (!hasValidPriceOrAvailability) {
      return false;
    }
    if (payload.overrides) {
      prevUpdate.overrides = payload.overrides;
    }
    if (payload.price) {
      prevUpdate.price = payload.price;
    }
    return true;
  };
  const updateAvailability = (): boolean => {
    const isValidAvailability =
      typeof payload.availability === 'boolean' ||
      typeof prevUpdate.price === 'number' ||
      payload.availability === null;
    if (!isValidAvailability) {
      return false;
    }
    const isBooleanOrNull =
      typeof payload.availability === 'boolean' || payload.availability === null;
    if (isBooleanOrNull) {
      prevUpdate.availability = payload.availability;
    }
    applyOverrides();
    return true;
  };
  let updated = false;

  if (action === 'price') {
    updated = updatePrice();
  } else if (action === 'availability') {
    updated = updateAvailability();
  } else {
    return false;
  }

  if (updated) {
    prevUpdate.product = productId;
  }

  return updated;
};
